module.exports = __webpack_public_path__ + "static/media/blindcode3.9d6a1484.jpeg";